import React from 'react';
import { IQuestionnaireItemDateComponent } from '../../modules/unsw-fhir/Questionnaire';
import { Conditionals } from '../Fields/Conditional';
import { generateSimpleEnableWhenPredicate } from '../../modules/unsw-fhir/QuestionnaireResponse/helpers';
import { QuestionnaireItemValidator } from '../../modules/unsw-fhir-questionnaire/Utilities/Validators';
import {
  getPromptTexts,
  getSupportingLinkUris,
} from '../../modules/unsw-fhir/Questionnaire/extensions';
import DateField from '../Fields/DateField';
import { useModal } from '../../modules/unsw-modals';

const QuestionnaireTextItem = (props: IQuestionnaireItemDateComponent) => {
  const { enableWhen, ...rest } = props;
  const prompts = getPromptTexts(props);
  const supportLinks = getSupportingLinkUris(props);
  const { openSupportingLinks } = useModal();

  return enableWhen ? (
    <Conditionals
      question={props.linkId}
      enableWhens={enableWhen.map(ew => ({
        when: ew.question,
        is: generateSimpleEnableWhenPredicate(ew),
      }))}>
      {({ enabled }) => (
        <DateField
          informationText={prompts}
          name={props.linkId}
          supportingLink={
            supportLinks.length !== 0
              ? () => openSupportingLinks(supportLinks)
              : undefined
          }
          validate={QuestionnaireItemValidator(props)}
          enabled={enabled}
          {...rest}
        />
      )}
    </Conditionals>
  ) : (
    <DateField
      informationText={prompts}
      name={props.linkId}
      supportingLink={
        supportLinks.length !== 0
          ? () => openSupportingLinks(supportLinks)
          : undefined
      }
      validate={QuestionnaireItemValidator(props)}
      {...rest}
    />
  );
};

export default QuestionnaireTextItem;
